import { focusTrap } from "../utility/focusTrap"

const langSwitcher = document.querySelector('.language-switcher')
const langDropdown = document.querySelector('.language-switcher__dropdown')
const activeDropdown = document.querySelector('.language-switcher__active')
const trapFocus = focusTrap(langSwitcher, langDropdown)

var dropdownOpen = false

function toggleDropdown() {
	dropdownOpen ? closeDropdown() : openDropdown()
}

function openDropdown() {
	dropdownOpen = true
    langDropdown.classList.add('active')
    langSwitcher.classList.add('active')
	trapFocus.enter()
}

function closeDropdown() {
	dropdownOpen = false
    langDropdown.classList.remove('active')
	langSwitcher.classList.remove('active')
	trapFocus.exit()
}

if (langSwitcher) {
	langSwitcher.addEventListener('click', toggleDropdown)
	activeDropdown.addEventListener('click', toggleDropdown)
}